<template>
  <b-container class="about">
    <h2>About Me</h2>
    <b-row align-v="center">
      <b-col>
        <img src="/static/photos/alyson.jpg">
      </b-col>
      <b-col class="">
        <p>
          I am a natural-light freelance photographer located in the Colorado Springs, Colorado area.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'about'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about h2 {
  margin: 1em;
  text-transform: uppercase;
}
.about img {
  max-width: 100%;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue